import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { type UseQueryOptions, useQuery } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type QueryFnType = typeof groupActionsOrderingRepository.getAvailableSlots;
type ApiData = ExtractFnReturnType<QueryFnType>;
type UseGetAvailableSlotsOptions = {
  config?: UseQueryOptions<ApiData, AxiosError>;
};

const QUERY_KEY = "available-slots";

export const useGetAvailableSlots = ({ config }: UseGetAvailableSlotsOptions) => {
  const slug = useGetSlug();

  return useQuery<ApiData, AxiosError>({
    queryKey: [QUERY_KEY, slug],
    queryFn: () => groupActionsOrderingRepository.getAvailableSlots(slug),
    ...config,
  });
};
